/**************************************************
 * Nombre:       Landing
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {CircularProgress, Grid, Typography} from "@mui/material";
import {useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {obtenerDoc} from "../Servicios/BD/obtenerDoc";
import {OBJETIVOSLANDING} from "../Modulo_Creador_Landings/Constantes";
import Landing_Reunion_Grupal from "./Landing_Reunion_Grupal/Landing_Reunion_Grupal";
import Landing_Reunion_Individual from "./Landing_Reunion_Grupal/Landing_Reunion_Individual";

const Landing = () => {
    const parms = useParams()
    const navigate = useNavigate()
    const [datosLaniding, setDatosLanding] = useState({})


    const obtenerLanding = (landing) => {

        switch (landing.objetivo) {
            case OBJETIVOSLANDING[0]:
                return <Landing_Reunion_Grupal item={landing}/>
            case OBJETIVOSLANDING[1]:
                return <Landing_Reunion_Individual item={landing}/>
        }

    }

    useEffect(() => {
        if (parms && parms.id) {

            obtenerDoc('landings', parms.id).then((dox) => {
                if (dox.res && dox.data && dox.data.estado === 'Publicada') {
                    setDatosLanding(dox.data)
                } else {
                    navigate('Home')
                }
            })

        } else {
            navigate('Home')
        }

    }, [parms]);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            {datosLaniding.id ?

                obtenerLanding(datosLaniding)

                :
                <>
                    <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'} sx={{mt: 24}}>
                        <CircularProgress/>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'} sx={{mt: 2}}>
                        <Typography>Cargando contenido...</Typography>
                    </Grid>
                </>

            }


        </Grid>
    )

}
export default Landing